import React, {useState, useEffect} from 'react';
import { Link } from "react-router-dom";
import {askJoki} from '../../JOKI';

import './session-countdown.scss';

export default function SessionCountdown() {

    
    const [timeLeft, setTimeLeft] = useState(() => {
        const authData = askJoki({
            to: "AuthenticationService",
            key: "getAuthData",
            syncAsk: true
        });
        if(authData.AuthenticationService === null) {
            return 0;
        }

        return Math.round(((authData.AuthenticationService.expires_at * 1000) - Date.now())/1000);    
    });

    const showCountDownAt = process.env.REACT_APP_SESSION_TIMER_SHOW !== undefined ? parseInt(process.env.REACT_APP_SESSION_TIMER_SHOW) : -1;

    useEffect(() => {
        if(timeLeft > 0 && showCountDownAt >= 0) {
            const ticker = setInterval( () => tick(), 1000);
            return () => {
                clearInterval(ticker);
            }
        }
    });

    function tick() {
        setTimeLeft(timeLeft - 1);
    }

    if(showCountDownAt < 0) {
        return null;
    }

    // Do not show the counter if there is more than 10 minutes left in the session timer
    if(timeLeft > showCountDownAt ) {
        return null;
    }

    // Show session closed if the session timer has run down
    if(timeLeft <= 0) {
        return (
            <div className="session-countdown closed">
                <label>Session</label>
                <Link to="/"><p>CLOSED</p></Link>
            </div>
        )
    }

    const hrs = Math.floor(timeLeft/3600);
    const mins = Math.floor((timeLeft-(hrs*3600))/60);
    const secs = Math.floor(timeLeft - (hrs * 3600) - (mins*60));

    // console.log(hrs.toString().padStart(2, "0"));
    // console.log(mins.toString().padStart(2, "0"));
    // console.log(secs.toString().padStart(2, "0"));
    
    let timeText = `${hrs > 0 ? hrs.toString().padStart(2, "0") + ":": ""}${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;    

    

    return (
        <div className="session-countdown">
            <label>Session</label>
            <p>{timeText}</p>
        </div>
    )

}
